import { useQuery } from '@tanstack/react-query';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';
import { api } from '../api/endpoints';
import { DictionaryView } from '../features/dictionary/DictionaryView';

function DataDictionaryPage() {
  const { tab, tag } = Route.useSearch();
  const navigate = useNavigate();
  const stats = useQuery({ queryKey: ['tag-stats'], queryFn: api.tagStats, staleTime: 3_600_000 });
  return (
    <DictionaryView
      tab={tab ?? (tag ? 'tags' : 'fields')}
      stats={stats.data}
      focusTag={tag}
      onTab={(t) => navigate({ to: '/data-dictionary', search: { tab: t } })}
    />
  );
}

export const Route = createFileRoute('/data-dictionary')({
  validateSearch: z.object({
    tab: z.enum(['fields', 'tags']).optional(),
    tag: z.string().optional(),
  }),
  component: DataDictionaryPage,
});
